package fyi.moko.hotpl.ui.map

import fyi.moko.hotpl.domain.model.GeoPoint
import fyi.moko.hotpl.domain.model.Place

/**
 * Where the places map should point, shared by every [PlacesMap] actual so the three
 * platforms can't drift apart on it.
 *
 * The user's own location outranks the saved places. `PlaceDao` hands the list over
 * newest-first, so leaning on its head centred the map on whatever was saved last — for a
 * journal that spans a metro area, that's a pin two cities over with the user's own dot
 * off screen. A place only wins when it was *asked for*, i.e. [selectedPlaceId] names it.
 *
 * Places with no coordinates are skipped, selections included: a selected place that was
 * never located can't be a camera target.
 */
internal fun resolveMapTarget(
    places: List<Place>,
    selectedPlaceId: String?,
    userTarget: GeoPoint?,
): GeoPoint {
    val located = places.filter { it.latitude != null && it.longitude != null }
    return located.firstOrNull { it.id == selectedPlaceId }?.toGeoPoint()
        ?: userTarget
        ?: located.firstOrNull()?.toGeoPoint()
        ?: MapDefaults.FALLBACK_TARGET
}

private fun Place.toGeoPoint(): GeoPoint = GeoPoint(latitude!!, longitude!!)
